import type { FieldPath } from 'react-hook-form';

import type { CreateVoucherRequest } from '../types';

/**
 * Field validation mapping for each step
 * Defines which fields need to be validated before proceeding to the next step
 */
export const stepFieldMap: Record<number, FieldPath<CreateVoucherRequest>[]> = {
  // Step 0: Basic Information
  0: ['banner_url', 'title', 'code', 'period_start_date', 'period_end_date'],

  // Step 1: Target User Configuration
  1: [
    'target_configuration.quota',
    'target_configuration.max_use_per_user',
    'target_configuration.target_type',
    'acquisition_configuration.acquisition_type',
    'acquisition_configuration.valid_day_since_account_signup',
    'shipToCsv', // Conditionally required for SHIP_TO target type
  ],

  // Step 2: Usage Requirements
  2: ['condition_configuration.condition_type'],

  // Step 3: Product and Reward Configuration
  3: [
    'purchaseProducts',
    'reward_configuration.reward_type',
    'rewardDiscountProduct', // Conditionally required
    'rewardFreeProduct', // Conditionally required
  ],
};
